import styled from 'styled-components';

export const Z_INDEX_OVERLAY = 10;

const Overlay = styled.div`
  height: 100%;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.textPrimary_30};
  top: 0;
  z-index: ${Z_INDEX_OVERLAY};
  width: 100%;
  display: block;
`;

export default Overlay;
